import React from "react"
import autobind from "class-autobind"
import { Drawer, Card, CardHeader, FontIcon } from "material-ui"
import { amber50 } from "material-ui/styles/colors"
import AppStateStore from "../../../stores/AppStateStore"
import Notes from "../Notes"
import { IApprovalValidation, INoteObjectData } from "../../../models"
import _, {  } from "lodash"
interface IProps {
    open: boolean
    title: string
    objectData: INoteObjectData
    objectName: string
    closeNotesDrawer(): void
    dataType: string
    validationMessages?: IApprovalValidation[]
    readValidationMessage:(msgeId:string) => Promise<IApprovalValidation>
}

interface IState {
    open: boolean
    title: string
    
    
}

export default class NotesDrawerContent extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            open: props.open,
            title: props.title,
          
            
        }
        autobind(this)
    }

    componentWillReceiveProps(nextProps) {
        nextProps.open && this.setState({ open: nextProps.open })
    }

    render() {
        return (
            <Drawer
                open={this.state.open}
                width={1000}
                style={{ maxWidth: 1000 }}
                openSecondary
                docked={false}
                overlayStyle={{ zIndex: 2000 }}
                containerStyle={{
                    zIndex: 2000,
                    overflow: "unset",
                    opacity: this.props.open ? 1 : 0,
                    transition: "opacity 200ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms"
                }}
                onRequestChange={this.props.closeNotesDrawer}
            >
                <Card style={{ boxShadow: "none" }}>
                    <CardHeader
                        style={{ backgroundColor: AppStateStore.getDrawerHeaderColor(), height: 90, textAlign: "center" }}
                        title={
                            <h2 title={this.state.title}>{this.state.title.length > 60 ? this.state.title.substring(0, 61) + " ... " : this.state.title}</h2>
                        }
                        children={
                            <FontIcon
                                data-intercom-target={"Notes-Btn-Close-Note-Drawer"}
                                onTouchTap={this.props.closeNotesDrawer}
                                className="fa fa-close"
                                style={{ cursor: "pointer", fontSize: 25, color: amber50, position: "absolute", top: 35, left: 950 }}
                            />
                        }
                        titleColor={"white"}
                    />
                </Card>
                <Notes
                    objectData={this.props.objectData}
                    objectName={this.props.objectName}
                    dataType={this.props.dataType}
                    validationMessages={this.props.validationMessages}
                    readValidationMessage={this.props.readValidationMessage}
                />
            </Drawer>
        )
    }
}
